// SCA specific
import fourColCarousel from './lib/four-col-carousel';
import heroCarousel from './lib/hero-carousel';
import teamModal from './lib/team-modal';
import listingFilters from './lib/listing-filter';
import loadMoreLogos from './lib/load-more-logos';

window.addEventListener('load', () => {
  // Carousels
  heroCarousel.initHeroCarousel();
  fourColCarousel.initFourColCarousel();

  // Modals
  teamModal.initTeamModal();

  //Filters
  listingFilters.init('.logo-soup-block');

  // Load more {posts}
  loadMoreLogos.init('.logo-soup-block');
});
